import { useEffect, useRef, useState } from 'react';

import { formatUSDNoDecimals } from '../../helpers/helperFunctions';
import { CaptionText, H3, H4, P1, P3 } from '../../styles/FontStyles';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useAppSelector } from '../../app/hooks';
import { DEX_NET } from '../../routes/routes';
import {
  ArrowChevron,
  Button,
  Collapsable,
  Flexed
} from '../../styles/GlobalComponents';
import { color, colors } from '../../styles/GlobalStyles';
import { Icon, IconPortfolioOrders } from '../../styles/Icons';
import { Overlay } from './Overlay';
import { getMyHubsDexNet, getMyHubsKriptoTap } from './Portfolio.actions';
import { BoxPortfolio, SummaryGrid } from './Portfolio.styled';
import { PortfolioItem } from './PortfolioItem';

export const DexNetSummary = () => {
  const dispatch = useDispatch();

  const history = useHistory();
  const ref = useRef<any>(null);

  const [expanded, setExpanded] = useState(true);

  const { dexnet } = useAppSelector((state) => state.portfolio);

  const { isCanadaRestrictedUser, canBuyStakingPackages } = useAppSelector(
    (state) => state.auth.userInfo
  );

  useEffect(() => {
    if (dexnet !== null) return;
    dispatch(getMyHubsDexNet());
  }, [dispatch]);

  const [height, setHeight] = useState(ref?.current?.clientHeight);
  useEffect(() => {
    setHeight(ref?.current?.clientHeight);
  }, [dexnet]);

  return (
    <>
      <Flexed mb='20' center between rowSM>
        <H3 mbSM='10' color={colors.neutral900}>
          My Ultron DexNet HUB NFTs summary
        </H3>
        {!isCanadaRestrictedUser && (
          <Button
            maxWidth='350px'
            maxWidthSM='100%'
            onClick={() => history.push(DEX_NET)}>
            ADD DEXNET HUB NFT
          </Button>
        )}
      </Flexed>
      <SummaryGrid>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioOrders />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              Total DexNet hub NFT orders
            </CaptionText>
            <P1 bold flex alignEnd gap='5px'>
              {formatUSDNoDecimals(dexnet?.summary?.totalOrderAmount || 0)}{' '}
              <P3 mb='1'>USDT</P3>
            </P1>
          </div>
        </BoxPortfolio>
      </SummaryGrid>

      <Flexed
        mb='20'
        center
        gap='20px'
        pointer
        onClick={() => setExpanded(!expanded)}>
        <H4 color={colors.neutral0}>My Ultron DexNet HUB NFTs</H4>
        <ArrowChevron direction={expanded ? 'up' : 'down'} />
      </Flexed>

      <Collapsable expanded={expanded} elementHeight={height}>
        <div ref={ref}>
          {dexnet?.userPackages?.map((item, index) => (
            <PortfolioItem key={index} item={item} />
          ))}
        </div>
      </Collapsable>

      <Overlay />
    </>
  );
};
